<script lang="ts">
  import AUPopover from "component_library/components/svelte/ui/AUPopover.svelte"
  import {
    getFloatingActionPlacement,
    type WidgetPosition,
  } from "website_script/lib/widgetPosition"
  import Prompt from "website_script/Prompt/Prompt.svelte"
  import WidgetPromptAction from "website_script/components/WidgetPromptAction.svelte"
  import type { PromptConfig } from "website_script/types/settings"
  import type { ButtonConfig } from "website_script/types/widgets"
  import IntegrationTypes from "website_script/constants/IntegrationTypes"
  import { getFlowsContext } from "website_script/contexts/flows"

  export let widgetPosition: WidgetPosition
  export let promptConfig: PromptConfig
  export let buttonConfig: ButtonConfig
  export let integrationType: IntegrationTypes
  export let showArrow: boolean = true
  let popover: AUPopover
  export const getPopoverInstance = () => popover

  const { triggerFlow } = getFlowsContext()

  const placement = getFloatingActionPlacement(widgetPosition)
</script>

<div
  class="popover-wrapper"
  role="button"
  tabindex="0"
  aria-label={promptConfig.title || "Open popover"}
  on:click={() => {
    triggerFlow(buttonConfig, integrationType)
    popover.close()
  }}
  on:keydown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      triggerFlow(buttonConfig, integrationType)
      popover.close()
    }
  }}
>
  <AUPopover
    bind:this={popover}
    startOpened={true}
    fitToContent={buttonConfig.prompt_type === "simple"}
    {placement}
    {showArrow}
  >
    <Prompt
      onClose={(e) => {
        e.stopPropagation()
        popover.close()
      }}
      type={buttonConfig.prompt_type}
    >
      <span slot="title">{promptConfig.title}</span>
      <span slot="description">{promptConfig.description}</span>
      <WidgetPromptAction
        slot="action"
        {popover}
        {buttonConfig}
        {promptConfig}
        {integrationType}
      />
    </Prompt>
  </AUPopover>
</div>

<style>
  .popover-wrapper {
    display: contents;
  }
</style>
